/**
 * Deterministic 3-char badge abbreviation: take the first three
 * characters of the name and upper-case them. Drops a trailing
 * " line" / " Line" suffix first so "Central line" → "CEN" rather
 * than the also-correct-but-uglier "CEN" via direct slice (the
 * suffix-strip is a no-op for already-short names like "DLR").
 *
 * Shared between {@link RouteVariantRow} and the Playwright visual
 * harness in `tests/visual/route-variant-row.spec.ts` so both stay
 * byte-for-byte in sync.
 */
export function abbreviate(name: string): string {
  return name
    .trim()
    .replace(/\s+line$/i, '')
    .slice(0, 3)
    .toUpperCase()
}
